// extracted by mini-css-extract-plugin
export var activeFilterButton = "_qx-c";
export var backButton = "_qx-4";
export var backIcon = "_qx-5";
export var chevronShortcut = "_qx-6";
export var container = "_qx-1";
export var editor = "_qx-8";
export var editorWrapper = "_qx-7";
export var prefix = "_qx-2";
export var searchIcon = "_qx-3";
export var suffix = "_qx-9";
export var suffixContent = "_qx-a";
export var suffixText = "_qx-b";
export var wrapper = "_qx-0";